import { useEffect, useState } from 'react'

const MAX_MOBILE_WIDTH = 750
const MAX_TABLET_WIDTH = 900

export const useScreenDetector = () => {
  const [width, setWidth] = useState(0)

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange)
    handleWindowSizeChange()
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  const isMobile = width ? width <= MAX_MOBILE_WIDTH : false
  const isTablet = width ? width <= MAX_TABLET_WIDTH : false

  return { isMobile, isTablet }
}
